export default "__VITE_ASSET__C3OV_3Iq__"